import api from "./axios";

class ServiceMessages {
  async save(payload) {
    const { data } = await api.post("/menssages", payload)
    return data.id;
  }

  async update(payload) {
    await api.put(`/menssages/${payload.id}`, payload);
  }

  async delete(id) {
    await api.delete(`/menssages/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/menssages/${id}`);
    return data;
  }

  async fillComobobox() {
    const { data } = await api.get(`/menssages/combobox`);
    return data;
  }
}

export default new ServiceMessages()